import { ReactElement } from 'react';
import { Trans } from 'react-i18next';

import { ButtonLinkW, Description, EmptyStateIconW, EmptyStateW, NavLinkW } from './styled';

interface AchievementEmptyStateProps {
  addAchievementLink: string;
  onAddAchievement?: () => void;
}

export function AchievementEmptyState({
  addAchievementLink,
  onAddAchievement,
}: AchievementEmptyStateProps): ReactElement {
  return (
    <EmptyStateW>
      <EmptyStateIconW />
      <Description>
        {onAddAchievement ? (
          <Trans i18nKey="career.achievements.emptyState">
            Nothing is here yet.
            <ButtonLinkW onClick={onAddAchievement}>Create a goal</ButtonLinkW> to place sub-goals
            in progress!
          </Trans>
        ) : (
          <Trans i18nKey="career.achievements.emptyState">
            Nothing is here yet.
            <NavLinkW to={addAchievementLink}>Create a goal</NavLinkW> to place sub-goals in
            progress!
          </Trans>
        )}
      </Description>
    </EmptyStateW>
  );
}
